<template>
  <div>
    <div class="list_block">
      <transition name="fade01" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$store.commit('auth/login')
    this.$store.state.hasCancel = false
  }
}
</script>
